module.exports = __webpack_public_path__ + "img/sh_0924.93d84b27.jpg";